import { render, staticRenderFns } from "./BCXNavigationItem.vue?vue&type=template&id=07e812b0&scoped=true"
import script from "./BCXNavigationItem.vue?vue&type=script&lang=ts"
export * from "./BCXNavigationItem.vue?vue&type=script&lang=ts"
import style0 from "./BCXNavigationItem.vue?vue&type=style&index=0&id=07e812b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e812b0",
  null
  
)

export default component.exports